
"use client"

import Script from "next/script";
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from "react";
import { pageview } from "@/lib/gtagHelper"

// https://gaudion.dev/blog/setup-google-analytics-with-gdpr-compliant-cookie-consent-in-nextjs13
const GoogleAnalytics = ({ GA_MEASUREMENT_ID }: { GA_MEASUREMENT_ID: string }) => {
  // const pathname = usePathname()
  // const searchParams = useSearchParams()

  useEffect(() => {
    // const url = pathname + (searchParams?.toString() || '');
    const url = (typeof window !== 'undefined' ? window.location.pathname + window.location.search : '');
    pageview(GA_MEASUREMENT_ID, url);

  }, [GA_MEASUREMENT_ID]);

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {
          `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', '${GA_MEASUREMENT_ID}');`
        }
      </Script>
    </>
  );
};

export default GoogleAnalytics;